import React from 'react';
import { func } from 'prop-types';

const BackToTop = ({ scrollTop }) => {
  return (
    <div className="back-to-top grid-x align-center">
      <div className="cell small-4">
        <a href="#header" onClick={scrollTop} className="back-to-top-button ds-lg">Back To Top</a>        
        <a href="#search-panels" onClick={scrollTop} className="back-to-top-button ds-sm">Back To Top</a>
      </div>
    </div>
  );
};

BackToTop.propTypes = {
  scrollTop: func.isRequired
};

export default BackToTop;
